import { render, staticRenderFns } from "./Instances.vue?vue&type=template&id=6bad272d&"
import script from "./Instances.vue?vue&type=script&lang=js&"
export * from "./Instances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports